module.exports = __webpack_public_path__ + "media/img/icons/angle-right-3db9f55041c82a4640e3da79de88105c.svg";